function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 20C4 21.1046 4.89543 22 6 22H9C10.1046 22 11 21.1046 11 20V4C11 2.89543 10.1046 2 9 2H6C4.89543 2 4 2.89543 4 4V20ZM10 5H7V6H10V5ZM10 7H8V8H10V7ZM10 9H7V10H10V9ZM10 11H8V12H10V11ZM10 13H7V14H10V13ZM10 15H8V16H10V15ZM10 17H7V18H10V17ZM10 19H8V20H10V19Z",
  fill: "#C8206F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19 2H13V4H15V20H13V22H19V20H17V4H19V2Z",
  fill: "#C8206F"
});

var SvgHeight = function SvgHeight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/height.a98dd980.svg";
export { ForwardRef as ReactComponent };